import { FC } from 'react';
import { ColumnCell } from '../types/ColumnCell';

type TableProps = {
  columns: ColumnCell[];
  rowClassName?: string;
};

const TableHeader: FC<TableProps> = ({
  columns,
  rowClassName = 'nk-tb-item tb-tnx-head',
}) => (
  <thead>
    <tr className={rowClassName}>
      {columns.map((column) => {
        const {
          key,
          content,
          textPosition = 'left',
          hideOnMobile = false,
          verticalAlignMiddle = false,
        } = column;

        return (
          <th
            key={key}
            className={[
              'nk-tb-col',
              `text-${textPosition}`,
              hideOnMobile && 'tb-col-xl',
              verticalAlignMiddle && 'vertical-align-middle',
              column?.className || '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {content}
          </th>
        );
      })}
    </tr>
  </thead>
);

export default TableHeader;
